import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'pdr-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Persona Doctors',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 8885771570,
  email: 'support@persona-doctors.com',
  poweredByLogo: true,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/pdr/index.js